export default __webpack_public_path__ + "static/media/1714.509d1fc5.png";